export const Types = {
    DAY_PACKAGES_LIST: "DAY_PACKAGES_LIST",
    DAY_PACKAGES_DATA_BYID: "TRDAY_PACKAGESATA_BYID",
    // UPDATE_TRAVELLER_DATA: "UPDATE_TRAVELLER_DATA",

  };
  